function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Avatar as MUIAvatar, makeStyles } from '@material-ui/core';
const Avatar = forwardRef(({
  backgroundColor,
  children,
  size,
  ...props
}, ref) => {
  const sizes = {
    small: 50,
    default: 75,
    large: 100
  };
  const useStyles = makeStyles(theme => ({
    avatar: {
      backgroundColor,
      border: `1px solid ${theme.palette.grey[600]}`,
      color: 'black',
      height: sizes[size],
      width: sizes[size]
    },
    avatarImg: {
      height: 'auto'
    }
  }));
  const classes = useStyles();
  return React.createElement(MUIAvatar, _extends({
    classes: {
      img: classes.avatarImg,
      root: classes.avatar
    }
  }, props, {
    ref: ref
  }), children);
});
Avatar.propTypes = {
  backgroundColor: PropTypes.string,
  size: PropTypes.string
};
Avatar.defaultProps = {
  backgroundColor: 'white',
  size: 'default'
};
export default Avatar;